function makeAStar(centerx, centery, steps=5, outerr=22, innerr=11) {
    let n = 0;//a counter
    let c = {x:centerx,y:centery};//the center of the svg canvas
    let step = Math.PI/steps;//since the star has 5 points you will need to calculate the position of a point every 36degs i.e Math.PI/5;
    let path = ""

//a for loop to calculate the position of the points for the star
    for(let a=-Math.PI/2;  a<3*Math.PI/2; a+= step){
        //The point will be either on the outer circle (r=22) or on the inner one (r=11)
        let r = n%2 == 0 ? outerr : innerr;
        //calculate the x and y of the point
        let x = c.x + r*Math.cos(a);
        let y = c.y + r*Math.sin(a);
        //push the x and the y values to the pts array

        if (!path) {
            path += `M ${x} ${y}`
        } else {
            path += ` L ${x} ${y}`
        }
        //increase the counter
        n++
    }

    return path;
}


export class DateProgressElement extends HTMLElement {
    static observedAttributes = ["begin", "end", "text"]

    constructor() {
        // Always call super first in constructor
        super();
        console.log("ziege-progress constructed")
    }

    connectedCallback() {
        const shadowE = this.attachShadow({ mode: "open" });
        const wrapperE = document.createElement("div")

        const progressE = document.createElement("div")
        const progressBgE = document.createElement("div")


        const explainE = document.createElement("div")

        shadowE.appendChild(wrapperE)
        wrapperE.appendChild(progressBgE)
        wrapperE.appendChild(progressE)
        wrapperE.appendChild(explainE)

        wrapperE.style.position = "relative";
        wrapperE.style.width = "100%";
        wrapperE.style.paddingTop = "5px";

        progressE.style.backgroundColor = "rebeccapurple"
        progressE.style.position = "absolute";
        progressE.style.height = "5px"
        progressE.style.left = "0";
        progressE.style.right = "0";
        progressE.style.top = "0";

        progressBgE.style.position = "absolute";
        progressBgE.style.left = "0";
        progressBgE.style.right = "0";
        progressBgE.style.top = "0";
        progressBgE.style.height = "5px";
        progressBgE.style.backgroundColor = "#eee";

        explainE.style.textAlign = "center"
        explainE.style.color = "#333"
        explainE.style.fontSize = "0.8rem"
        explainE.style.padding = "0.2rem";


        this.beginDate = this.getAttribute("begin")
        this.endDate = this.getAttribute("end")

        this.explainText = this.getAttribute("text")
        explainE.innerText = this.explainText


        this.updateProgress = () => {
            const dtBegin = new Date(parseInt(this.beginDate))
            const dtEnd = new Date(parseInt(this.endDate))
            const dtNow = new Date()

            let progress = ((dtNow - dtBegin) / (dtEnd - dtBegin)) * 100
            progress = Math.min(progress, 100)
            progressE.style.width = `${progress}%`
            explainE.innerText = this.explainText
        }
        this.updateProgress()

        this.intervalId = window.setInterval(this.updateProgress, 3600 * 1000);
    }

    disconnectedCallback() {
        if (this.intervalId) {
            window.clearInterval(this.interval);
        }
    }



    attributeChangedCallback(name, oldValue, newValue) {
        console.log("attribute change on date progress")
        if (name === "begin") {
            this.beginDate = newValue;
            window.setTimeout(this.updateProgress)
        } else if (name === "end") {
            this.endDate = newValue;
            window.setTimeout(this.updateProgress)
        } else if (name === "text") {
            this.explainText = newValue;
            window.setTimeout(this.updateProgress)
        }
    }

}

export  class ZiegeProgressElement extends HTMLElement {
    static observedAttributes = ["value", "max" ];
    // completion is string of 0 or 1 for every grass. All 1s for grasses gives an ok flower.
    // otherwise a bad flower. Goat is positioned accorind to completion.

    constructor() {
        // Always call super first in constructor
        super();
        console.log("ziege-progress constructed")
    }

    connectedCallback() {
        //<svg width="450" height="450">
        //<path
        //d="M 145 174 A 146 144 81 0 0 193 314"
        //stroke="#fa3838" stroke-width="20" fill="none"
        ///>
        //</svg>

        this.progressAudio = new Audio("static/progress.wav");
        this.completionAudio = new Audio("static/completion.wav");

        const shadowE = this.attachShadow({ mode: "open" });
        const svgE = document.createElementNS("http://www.w3.org/2000/svg", "svg");
        const pathE = document.createElementNS("http://www.w3.org/2000/svg", "path");
        const fillE = document.createElementNS("http://www.w3.org/2000/svg", "g");
        const symbolE = document.createElementNS("http://www.w3.org/2000/svg", "g");

        fillE.classList.add("filling");

        svgE.setAttribute("viewBox", "-5 -5 210 30");
        svgE.style.width = "100%"
        svgE.style.height = "100%"
        svgE.style.strokeLinejoin = "round";
        svgE.style.animation

        const svgStyleE = document.createElementNS("http://www.w3.org/2000/svg", "style");

        svgE.appendChild(svgStyleE)
        svgStyleE.textContent = `


.symbols *:nth-child(2) {
    animation: .4s jump ease 2 alternate;
}

@keyframes jump {
  0% {
    transform: scale(1);
    box-shadow: 0 1px 2px rgba(0,0,0,.15);
  }
  100% {
    transform: scale(1.05);
    box-shadow: 0 4px 20px rgba(0,0,0,.1);
  }
}


`



        const strokeWidth = 2

        svgE.appendChild(fillE);
        svgE.appendChild(pathE);
        shadowE.appendChild(svgE);
        pathE.setAttribute("stroke", "#fa3838");
        pathE.setAttribute("stroke-width", `${strokeWidth}`);


        fillE.setAttribute("fill", "#fa3838");
        fillE.setAttribute("fill-rule", "evenodd");

        //fillPathE.setAttribute("stroke", "blue");
        //fillPathE.setAttribute("stroke-width", `${strokeWidth}`);

        pathE.setAttribute("fill", "none");



        // r ist 10 und l ist 100
        // n ist 0 (2 Pömpel gibt es immer. n sind die extra pömpel)
        // oberer Arc erster Bömpel:
        // Beginn: 0,10
        // Ende: 20,15
        //
        // unterer Arc erster Bömpel
        // Beginn 0,10
        // Ende: r + sqrt(3/4 * r**2),5  // hier: 18.66, 5

        // mehr pömpel. z.B. einer in der Mitte n=1
        // spacing ist l - 2 * (r + sqrt(3/4 * r**2)) / (n+1)

        const r = 10.0 // radius der pömpel, vertikaler abstand der Striche
        const l = 200.0 // gesamt länge des Konstrukts
        const n = parseInt(this.getAttribute("max")) - 1 // anzahl extra pömpel auf dem Weg

        const d = Math.sqrt(3.0/4.0 * r * r) // horziontale länge des Kreisabschnitts.
        let a = l - 2*(d+r) - (n*2*d) // restliche strecke. Abstand zwischen bömpeln
        if (n > 0) {
            a = a / (n + 1)
        }

        // linker Pömepel
        const leftBlobTop = `M 0 ${r} A ${r} ${r} 0 0 1 ${r+d} ${r/2}`
        const leftBlobBottom = `M 0 ${r} A ${r} ${r} 0 0 0 ${r+d} ${r * 1.5}`

        // rechter Pömpel
        const rightBlobTop = `M ${l} ${r} A ${r} ${r} 0 0 0 ${l-(r+d)} ${r/2}`
        const rightBlobBottom = `M ${l} ${r} A ${r} ${r} 0 0 1 ${l-(r+d)} ${r * 1.5}`

        let lines = ""
        let blobs = ""
        let fillings = []
        let symbols = []

        fillings.push(`M 0 ${r} A ${r} ${r} 0 1 1 ${2*r} ${r} M 0 ${r} A ${r} ${r} 0 1 0 ${2*r} ${r}`) // erster blob
        fillings.push(` M ${l} ${r} A ${r} ${r} 0 1 0 ${l-(2*r)} ${r} M ${l} ${r} A ${r} ${r} 0 1 1 ${l - (2*r)} ${r}`) // letzter blob
        fillings.push(` M ${strokeWidth} ${r/2} L ${l-strokeWidth} ${r/2} L ${l-strokeWidth} ${r * 1.5} L ${strokeWidth} ${r* 1.5} L ${strokeWidth} ${r/2}`) // linie dazwischen

        symbols.push(`M ${r+r/2} ${r} L ${r-r/2} ${r-r/2} L ${r-r/2} ${r+r/2}`) // play button for first thing.




        for (let pmpl = 0; pmpl < (n+1); pmpl++) {
            let start = (r+d) + pmpl * a + pmpl * 2 * d
            let stop = start + a
            lines += ` M ${start - strokeWidth/2} ${r/2} L ${stop + strokeWidth/2} ${r/2} M ${start-strokeWidth/2} ${r * 1.5} L ${stop + strokeWidth/2} ${r * 1.5}`
            if (pmpl+1 < (n+1)) {
                const endBlobTop = `M ${stop} ${r * 1.5} A ${r} ${r} 0 0 0 ${stop + 2 * d} ${r * 1.5}`
                const endBlobBottom = `M ${stop} ${r / 2} A ${r} ${r} 0 0 1 ${stop + 2 * d} ${r / 2}`
                blobs += ` ${endBlobTop} ${endBlobBottom} `

                fillings.push(`M ${stop} ${r} A ${r} ${r} 0 1 0 ${stop + 2 * r} ${r} M ${stop} ${r} A ${r} ${r} 0 1 1 ${stop + 2 * r} ${r}`)
                symbols.push(makeAStar(stop + d, r, 5, r*0.8, r*0.4))

            }
        }
        //d="M 0 10 A 10 10 0 0 1 18.66025403784439 5 M 0 10 A 10 10 0 0 0 18.66025403784439 15  M 18.66025403784439 5 L 41.33974596215561 5 M 18.66025403784439 15 L 41.33974596215561 15 M 58.66025403784438 5 L 81.3397459621556 5 M 58.66025403784438 15 L 81.3397459621556 15  M 100 10 A 10 10 0 0 1 81.3397459621556 15 M 100 10 A 10 10 0 0 0 81.3397459621556 5"
        pathE.setAttribute("d", `${leftBlobTop} ${leftBlobBottom} ${lines} ${blobs} ${rightBlobBottom} ${rightBlobTop}`)

        fillings.forEach(filling => {
            const fillPathE = document.createElementNS("http://www.w3.org/2000/svg", "path");
            fillPathE.setAttribute("d", filling)
            fillE.appendChild(fillPathE);
        })
        fillE.style.transition = "clip-path 1s";


        symbols.forEach(symbol => {
            const symbolPathE = document.createElementNS("http://www.w3.org/2000/svg", "path");
            symbolPathE.setAttribute("d", symbol)
            symbolE.appendChild(symbolPathE);

        })
        symbolE.style.fill = "gold"
        symbolE.style.filter = "drop-shadow(1px 2px 2px rgb(0 0 0 / 0.2))";
        symbolE.classList.add("symbols")


        fillE.appendChild(symbolE)


        this.updateProgress = (progress) => { // progress in filled bömpels 0 <= progress <=n
            let progressPixels = 0
            if (progress > 0) {
                progressPixels += r-d + r - d + (strokeWidth/4)
                progressPixels += (progress - 1) * a
            }

            progressPixels += progress * 2*d ;

            fillE.style.clipPath = `inset(0 ${l-progressPixels}px 0 0)`
        }

        this.updateProgress(0)


        /*pathE.setAttribute("d", "M 0 10 A 10 10 0 0 1 18.66 5 M 0 10 A 10 10 0 0 0 18.66 15 M 18.66 15 L 81.34 15 M 18.66 5 L 81.34 5 " +
            "M 100 10 A 10 10 0 0 0 81.34 5 M 100 10 A 10 10 0 0 1 81.34 15" // bömpel rechts
        );*/
    }



    XXconnectedCallback() {
        const goatUri = "static/goat.svg"
        const grassUri = "static/grass.svg"
        const flowerUri = "static/flower.svg"
        const successUri = "static/success.svg"
        const failUri = "static/fail.svg"

        const flowers = parseInt(this.getAttribute("flowers"))
        const grass = parseInt(this.getAttribute("grass"))
        const completion = this.getAttribute("completion");

        const shadow = this.attachShadow({ mode: "open" });


        const imgGoat = document.createElement("img")
        imgGoat.src = "static/goat.svg"
        imgGoat.style.width = "auto"
        imgGoat.style.height = "2rem"

        shadow.appendChild(imgGoat);

        for (let flw = 1; flw <= flowers; flw++) {
            for (let grs = 1; grs <= grass; grs++) {
                const imgGrass = document.createElement("img")
                imgGrass.src = "static/simplegrass.svg"
                imgGrass.style.width = "auto"
                imgGrass.style.height = "1rem"

                shadow.appendChild(imgGrass);
            }
            const imgFlower = document.createElement("img")
            imgFlower.src = "static/redflower.svg"
            imgFlower.style.width = "auto"
            imgFlower.style.height = "1.2rem"

            shadow.appendChild(imgFlower);

        }

        const imgFlower = document.createElement("img")
        imgFlower.src = "static/blueflower.svg"
        imgFlower.style.width = "auto"
        imgFlower.style.height = "1.5rem"

        shadow.appendChild(imgFlower);

    }

    disconnectedCallback() {
    }

    connectedMoveCallback() {
    }

    adoptedCallback() {
    }

    attributeChangedCallback(name, oldValue, newValue) {
        if (name == "value" && oldValue !== newValue) {
            if (this.updateProgress) {
                this.updateProgress(parseInt(newValue));
                if (newValue == this.getAttribute("max")) {
                    this.completionAudio.play()
                } else if (parseInt(newValue) > parseInt(oldValue)) {
                    this.progressAudio.play()
                }
            }
        }
    }
}

